<h3 mat-dialog-content>{{ dialogTitle }}</h3>

<p class="alert alert-danger mt-3">
	Pamiętaj, że zmieniasz dane klienta. Zostaną one naniesione we wszystkich jego rezerwacjach.
</p>

@if (!!data.ownerUser) {
	<ng-container [formGroup]="formGroup">
		<div class="d-flex flex-row gap-2 justify-content-between">
			<mat-form-field appearance="outline">
				<mat-label>Zwrot grzecznościowy</mat-label>
				<mat-select formControlName="sex" placeholder="Pan">
					<mat-option value="M">Pan</mat-option>
					<mat-option value="F">Pani</mat-option>
				</mat-select>
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Imię</mat-label>
				<input type="text" matInput formControlName="firstName" />
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Nazwisko</mat-label>
				<input type="text" matInput formControlName="lastName" />
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" class="example-form-field">
				<mat-label>Data urodzenia</mat-label>
				<input matInput [matDatepicker]="datepicker" formControlName="birth" />
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
				<mat-datepicker #datepicker>
					<mat-datepicker-actions>
						<button mat-button matDatepickerCancel>Anuluj</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Obywatelstwo</mat-label>
				<mat-select formControlName="nationality">
					@for (nationality of nationalities; track nationality) {
						<mat-option [value]="nationality.id">{{ nationality.name }}</mat-option>
					}
				</mat-select>
				<mat-error> To pole jest wymagane</mat-error>
			</mat-form-field>
		</div>
		<div class="d-flex flex-row gap-2 mt-1 flex-nowrap ownerData_secondColumn">
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Numer dowodu osobistego</mat-label>
				<input type="text" matInput formControlName="idNumber" />
				<mat-error> Wprowadź poprawny numer dowodu osobistego </mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Numer paszportu</mat-label>
				<input type="text" matInput formControlName="passportNumber" />
				<mat-error> Wprowadź poprawny numer paszportu</mat-error>
			</mat-form-field>
			<ng-template #passportNumber>
				<mat-form-field appearance="outline" class="flex-fill">
					<mat-label>Numer dokumentu</mat-label>
					<input type="text" matInput formControlName="passportNumber" />
				</mat-form-field>
			</ng-template>
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Adres e-mail</mat-label>
				<input type="text" matInput formControlName="email" />
				<mat-error>
					@if (controlFilledIncorrectly('email')) {
						Wprowadź poprawny adres email
					} @else {
						To pole jest wymagane
					}
				</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Numer telefonu</mat-label>
				<input matInput type="text" placeholder="Numer telefonu" formControlName="phoneNumber" />
				<mat-error class="phone-number-error">
					@if (controlFilledIncorrectly('phoneNumber')) {
						Wprowadź poprawny numer telefonu
					} @else {
						To pole jest wymagane
					}
				</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Kod pocztowy</mat-label>
				<input matInput type="text" placeholder="Kod pocztowy" formControlName="zipCode" />
				<mat-error class="zip-code-error">Wprowadź prawidłowy kod pocztowy (xx-xxx)</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Miasto</mat-label>
				<input matInput type="text" placeholder="Miasto" formControlName="city" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Ulica nr domu / nr lokalu</mat-label>
				<input matInput type="text" placeholder="Ulica" formControlName="street" />
			</mat-form-field>
		</div>
	</ng-container>

	<div>
		<mat-checkbox [(ngModel)]="data.ownerUser.regularCustomer">Stały klient </mat-checkbox>
	</div>
}

<mat-dialog-actions align="end">
	<button mat-button class="deny-changes-button" (click)="closeDialog()">Porzuć</button>
	@if (data.ownerUser) {
		<button mat-raised-button color="primary" (click)="submit()">Zapisz zmiany</button>
	}
</mat-dialog-actions>
